import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth/auth.service';
import { LibraryService } from '../library.service';

export interface DialogData {
    titulo: string,
    mensaje: string,
    payload: any,
    textoCerrar: string,
    textoAceptar: string,
    labelTexto?: string,
}

@Component({
    selector: 'generic-dialog-confirmacion-datepicker',
    templateUrl: './generic-dialog-confirmacion-datepicker.component.html',
})
export class GenericDialogConfirmacionDatepicker {
    
    fecha: Date;
    labelTexto: string;

    constructor(
        public dialogRef: MatDialogRef<GenericDialogConfirmacionDatepicker>,
        public auth: AuthService,
        public libraryService: LibraryService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {
        if(data.labelTexto) this.labelTexto = data.labelTexto;
    }

    cerrar() {
        let fechaFormato = this.libraryService.convertirFecha(this.fecha, 'date', 'YYYY-MM-DD');
        this.dialogRef.close({ result: 'cerrar', fecha: fechaFormato });
    }

    confirmar() {
        let fechaFormato = this.libraryService.convertirFecha(this.fecha, 'date', 'YYYY-MM-DD');
        this.dialogRef.close({ result: 'confirmar', fecha: fechaFormato });
    }
    
}